import { Box, TextField, Typography } from '@mui/material';

import classes from './ErrorBox.scss';
import ErrorIcon from '@mui/icons-material/Error';
type LoaderProps = {
  title?: string;
  message?: string;
  warning?: boolean;
};

const ErrorBox: React.FC<LoaderProps> = ({ title, message, warning }) => {
  if (!title) {
    return null;
  }
  return (
    <Box
      component="div"
      sx={{
        flexDirection: 'row',
        display: 'flex',
        width: '100%',
      }}
    >
      <>
        <ErrorIcon />
        <Box style={{ flexShrink: 1 }}>
          {title ? <Typography className={'error-box'}>{title}</Typography> : null}
          {message ? <Typography className={'errorMessage'}>{message}</Typography> : null}
        </Box>
      </>
    </Box>
  );
};

export default ErrorBox;
